import { styled } from "@mui/material";
import Box from "@mui/material/Box";

const ResultBox = styled(Box)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  borderWidth: 1,
  borderStyle: "solid",
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: "column",
}));

export default ResultBox;
